import React from "react";
import "../Carousel/carouselbanner.css";
import banner1 from "../../../../images/newproductslider/newhome_banner1.jpeg";
import banner2 from "../../../../images/newproductslider/newhome_banner2.jpeg";
import banner3 from "../../../../images/newproductslider/newhome_banner3.jpeg";

function SimpleCarousel() {

    return (
        <div className="container-fluid p-0">

            <div id="carouselExampleDark" className="carousel slide" data-ride="carousel" data-interval="3000" data-pause="false">

                {/* Indicators */}
                <ol className="carousel-indicators">
                    <li data-target="#carouselExampleDark" data-slide-to="0" className="active"></li>
                    <li data-target="#carouselExampleDark" data-slide-to="1"></li>
                    <li data-target="#carouselExampleDark" data-slide-to="2"></li>
                </ol>

                {/* Slides */}
                <div className="carousel-inner">

                    <div className="carousel-item active">
                        <img src={banner1} className="d-block w-100" alt="slide1" />
                        <div className="carousel-caption custom-caption">
                            <h1>ACOUSTICAL<br /> PRODUCTS<br /> MANUFACTURER</h1>
                            <p> we manufacturer quality acoustical products <br />
                                in technology partnership with acoustical surfaces inc, usa</p>
                        </div>
                    </div>

                    <div className="carousel-item">
                        <img src={banner2} className="d-block w-100" alt="slide2" />
                        <div className="carousel-caption custom-caption">
                            <h1>ACOUSTICAL<br /> PRODUCTS<br /> MANUFACTURER</h1>
                            <p> we manufacturer quality acoustical products <br />
                                in technology partnership with acoustical surfaces inc, usa</p>
                        </div>
                    </div>

                    <div className="carousel-item">
                        <img src={banner3} className="d-block w-100" alt="slide3" />
                        <div className="carousel-caption custom-caption">
                            <h1>ACOUSTICAL<br /> PRODUCTS<br /> MANUFACTURER</h1>
                            <p> we manufacturer quality acoustical products <br />
                                in technology partnership with acoustical surfaces inc, usa</p>
                        </div>
                    </div>

                </div>

                {/* Previous */}
                <a
                    className="carousel-control-prev"
                    href="#carouselExampleDark"
                    role="button"
                    data-slide="prev"
                >
                    <span className="carousel-control-prev-icon"></span>
                </a>

                {/* Next */}
                <a
                    className="carousel-control-next"
                    href="#carouselExampleDark"
                    role="button"
                    data-slide="next"
                >
                    <span className="carousel-control-next-icon"></span>
                </a>


            </div>

        </div>
    );
}

export default SimpleCarousel;